export default "__VITE_ASSET__wyLyedkk__"